export const specialFormatSelectedAccount = (
  selectedAccount: string,
): string => {
  // Special treatment for Soundtrap's account name. They joined early,
  // before the standard for account name was updated to be more human-readable.
  if (selectedAccount === 'vwesoxljqt20yjg5eu6j') {
    return 'Soundtrap';
  }

  return selectedAccount;
};
